export default __webpack_public_path__ + "static/media/logo_refueling.c4d45358.svg";